import TagManager from "react-gtm-module";
import { calcMemberPrice } from "utils/helpers";

export default {
	adClick,
	addToCart,
	checkout,
	init,
	pageView,
	removeFromCart,
	selectItem,
	setUserData,
	socialShare,
	viewItem,
};

function init() {
	const tagManagerArgs = {
		// gtmId: "GTM-W9W8M6F",
		gtmId: process.env.GTM,
		send_page_view: true,
	};

	TagManager.initialize(tagManagerArgs);
}
function pageView() {
	if (!window.dataLayer) return;

	window.dataLayer.push({
		event: "page_view",
		page_path: location.pathname + location.search + location.hash,
		page_search: location.search,
		page_hash: location.hash,
	});
}

//DATALAYER
function socialShare({ platform, title }) {
	if (!window.dataLayer) return;

	window.dataLayer.push({
		event: "share",
		method: platform,
		item_id: title,
	});
}

function adClick({ adName }) {
	if (!window.dataLayer) return;

	window.dataLayer.push({
		event: "ad_click",
		ad_name: adName,
	});
}

function setUserData(user = {}) {
	if (!window.dataLayer) return;

	window.dataLayer.push({
		event: "set_user_data",
		user_id: user?.id,
		is_member: user.isMember,
	});
}

function checkout(cartItems, user = {}) {
	if (!window.dataLayer) return;

	let subtotal = cartItems.reduce((acc, item) => {
		if (isNaN(item.price)) return acc;
		return acc + calcMemberPrice(item, user) * item.quantity;
	}, 0);

	window.dataLayer.push({
		event: "checkout",
		user_id: user?.id,
		is_member: user?.isMember,
		subtotal,
	});
}

function addToCart(variantData) {
	// console.log(window.dataLayer);
	if (!window.dataLayer) return;

	const { sku, price, name, deliveryFormat } = variantData;
	const item = {
		item_id: sku,
		price,
		quantity: 1,
		item_name: name,
		item_category: `deliveryFormat-${deliveryFormat}`,
	};

	window.dataLayer.push({
		event: "add_to_cart",
		currency: "USD",
		value: price,
		items: [item],
	});
}

function removeFromCart(variantData) {
	if (!window.dataLayer) return;

	const { sku, price, name, deliveryFormat } = variantData;
	const item = {
		item_id: sku,
		price,
		quantity: 1,
		item_name: name,
		item_category: `deliveryFormat-${deliveryFormat}`,
	};

	window.dataLayer.push({
		event: "remove_from_cart",
		currency: "USD",
		value: price,
		items: [item],
	});
}

function viewItem({ item_category, name, value }) {
	if (!window.dataLayer) return;

	window.dataLayer.push({
		event: "view_item",
		currency: "USD",
		value,
		items: [{ item_name: name, item_category }],
	});
}

function selectItem(fields, itemListName) {
	if (!window.dataLayer) return;

	const { title, price } = fields;

	const item_list_name = itemListName ? itemListName : getItemListName(fields);

	window.dataLayer.push({
		event: "select_item",
		// item_list_id: "", //EX: related_products - The ID of the list in which the item was presented to the user.
		//                   Ignored if set at the item-level.
		item_list_name, //EX Related products - The name of the list in which the item was presented to the user.
		//                     Ignored if set at the item-level.

		items: [
			{
				item_name: title,
				price,
			},
		], //The items array is expected to have a single element, representing the selected item. If multiple elements are provided, only the first element in items will be used.
	});
}

function getItemListName(fields) {
	const { productType, item_list_name } = fields;

	switch (productType) {
		case "Book":
			return "Book Products";
		case "Course":
			//TODO check the route?
			return "Course Products";

		case "Journal":
			return "Publication Products";

		default:
			return item_list_name;
	}
}
